import { baseURL } from "./axios"

export const getOnlineImage = (uri) => {
    return baseURL + 'uploads/' + uri
}